<template>
  <div>
    <h2>Projekte</h2>
    <p>
      Willkommen zu Ihren Projekten. Diese Seite zeigt die von Ihnen angelegten Projekte
      sowie ein Demo-Projekt. Klicken Sie auf ein Projekt, um es zu öffnen, nutzen Sie die
      Suche und Sortierung, um es schnell zu finden, verwalten Sie einzelne Projekte über
      das Optionen-Menü oder ein neues Projekt erstellen.
    </p>
    <p>Folgende Funktionen sind hier vorhanden:</p>
    <ul>
      <li>Projekte durchsuchen.</li>
      <li>Projekte sortieren (nach Erstellungsdatum oder Name).</li>
      <li>Projekt öffnen.</li>
      <li>Projekte verwalten (Umbenennen, Kopieren, Bemerkung, Senden, Löschen).</li>
      <li>Neues Projekt oder Demo-Projekt erstellen.</li>
    </ul>

    <v-expansion-panels accordion class="mt-5">
      <v-expansion-panel>
        <v-expansion-panel-title>
          <div class="heading">Zusätzliche Informationen</div>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <h3>Suchen &amp; Sortieren</h3>
            <p>
              Über das Suchfeld oben rechts filtern Sie die Liste nach dem Projektnamen.
              Mit der Auswahl „Sortieren nach“ ordnen Sie die Projekte nach Erstellungsdatum
              oder Name; über die Schaltfläche daneben wechseln Sie zwischen auf- und
              absteigender Reihenfolge.
            </p>

          <h3>Tabellenspalten</h3>
            <p>
              Die Liste zeigt zu jedem Projekt den Namen, das Erstellungsdatum, den Zeitpunkt
              der letzten Bearbeitung, den Absender einer gesendeten Projektkopie sowie eine
              frei hinterlegbare Bemerkung an.
            </p>

          <h3>Projektoptionen</h3>
            <p>
              Über das Menü (Symbol mit drei Punkten) in der Spalte „Option“ verwalten Sie das
              jeweilige Projekt:
            </p>
            <dl>
              <dt><strong>Umbenennen:</strong></dt>
              <dd>
                Ändert den Namen des Projekts.
              </dd>
              <dt><strong>Kopie erstellen:</strong></dt>
              <dd>
                Legt eine Kopie des Projekts an. Hinweis: Projekte mit einer noch nicht
                abgeschlossenen (Draft-)Maßnahme können nicht kopiert werden.
              </dd>
              <dt><strong>Bemerkung bearbeiten:</strong></dt>
              <dd>
                Bearbeitet den frei wählbaren Text, der in der Spalte „Bemerkung“ angezeigt wird.
              </dd>
              <dt><strong>Projektkopie senden:</strong></dt>
              <dd>
                Sendet eine Kopie des Projekts an einen anderen Benutzer.
              </dd>
              <dt><strong>Löschen:</strong></dt>
              <dd>
                Löscht das Projekt nach einer Sicherheitsabfrage. Diese Aktion kann nicht
                rückgängig gemacht werden.
              </dd>
            </dl>

          <h3>Projekte erstellen</h3>
            <p>
              Mit „Neues Projekt“ legen Sie ein leeres Projekt an. Über „Neues Demo Projekt“
              und „Neues Demo2 Projekt“ erzeugen Sie Beispielprojekte mit vorbefüllten Daten,
              um die Anwendung kennenzulernen.
            </p>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Vuetify Footer -->
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "ProjectListHelp",
});
</script>

<style scoped>
</style>
